<template>
  <div>
    <!-- <detailHeader /> -->
    <el-dialog :title="$t('message.directPacking')" :visible.sync="$parent.boxDialogVisible" width="1860px"
      :close-on-click-modal="false" @close="$parent.uploadBoxList" center v-if="!$route.query.id">
      <div class="encasement-status">
        <div class="status">{{ detail.status_name }}</div>
        <div class="order-name">
          <!-- 业务 -->
          <div class="item">{{ $t("message.business") }}:{{ detail.y_name }}</div>
          <!-- 采购 -->
          <div class="item">{{ $t("message.purchase") }}:{{ detail.g_name }}</div>
          <!-- 配货 -->
          <div class="item">
            {{ $t("message.distribution") }}:{{ detail.p_name }}
          </div>
          <!-- 箱号 -->
          <div class="item">
            {{ $t("message.boxNO") }}:{{ detail.order_sn }}-{{ detail.box_no }}
          </div>
        </div>
      </div>
      <!-- 列表 -->
      <div class="encasementDetail">
        <!-- 装箱状态 -->
        <div class="table">
          <ol>
            <!-- 选择 -->
            <li class="flex05">{{ $t("message.choose") }}</li>
            <!-- 订单号 -->
            <li class="flex2">{{ $t("message.orderNumber") }}</li>
            <!--  番号-->
            <li class="flex05">
              {{ $t("message.mash") }}
            </li>
            <!--照片-->
            <li>
              {{ $t("message.pic") }}
            </li>
            <!-- 商品属性 -->
            <li class="flex15">{{ $t("message.commodityAttribute") }}</li>
            <!--本箱装货数  -->
            <li class="flex3">{{ $t("message.quantityOfCargoInThisCase") }}</li>
            <!-- 价格.元 -->
            <li>{{ $t("message.priceY") }}</li>
            <!--交易/物流号  -->
            <li class="flex2">
              {{ $t("message.transactionNumberLogisticsNumber") }}
            </li>
            <!-- 担当、商品备注 -->
            <li class="flex15">{{ $t("message.BearCommodityNoteEditing") }}</li>
            <!-- 采购、商品备注 -->
            <li class="flex15">{{ $t("message.purchaseCommodityNoteEditing") }}</li>
            <!-- 配货。商品备注 -->
            <li class="flex15">{{ $t("message.DistributionBearCommodityNoteEditing") }}</li>
          </ol>
          <!-- 无数据显示 -->
          <div class="noData" v-if="tableData == false">暂无数据</div>
          <!-- 订单详情 -->
          <ul v-for="(items, indexs) in tableData" :key="indexs">
            <!-- 选择 -->
            <li class="flex05">
              <label>
                <el-popover placement="right" title="合计" width="200" trigger="focus">
                  <statistics :selectList="checkedList" />
                  <el-checkbox v-model="items.checked" @change="changeItem" slot="reference"></el-checkbox>
                </el-popover>
              </label>
            </li>
            <!-- 订单号 -->
            <li class="flex2">
              <div>
                <p>
                  <router-link :to="'/orderPaymentDetail?order_sn=' + items.order_sn" target="_blank" class="a-link">
                    {{ items.order_sn }}
                  </router-link>
                </p>
                <p>{{ items.realname }}</p>
              </div>
            </li>
            <!--   番号-->
            <li class="flex05">
              {{ items.sorting }}
            </li>
            <!--照片-->
            <li>
              <div>
                <div class="img">
                  <el-popover placement="right" width="300" trigger="hover">
                    <img :src="items.pic" alt="" style="width: 300px; height: 300px" />
                    <a :href="items.origin_link" target="_blank" slot="reference">
                      <img :src="items.pic" alt="" />
                    </a>
                  </el-popover>
                  <div class="contraband" v-if="items.forbid_goods != false">
                    <el-popover placement="right" width="200" trigger="hover">
                      <div>
                        {{ items.forbid_goods.type_name }}
                      </div>
                      <img src="@/assets/img/contraband1.png" alt="" slot="reference"
                        v-if="items.forbid_goods.status == 3">
                      <img src="@/assets/img/contraband.png" alt="" slot="reference" v-else>
                    </el-popover>
                  </div>
                </div>
              </div>
            </li>
            <!-- 商品属性 -->
            <li class="flex15">
              <div class="attribute">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(itemDetail, itemIndex) in items.detail_y" :key="itemIndex"
                      style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(itemDetail, itemIndex) in items.detail_y" :key="itemIndex">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!--本箱装货数  -->
            <li class="flex3">
              <div class="purchase">
                <div class="row" v-for="(purchase, purchaseIndex) in items.purchase" :key="purchaseIndex">
                  <span>
                    JY{{ purchaseIndex + 1 }}:{{ purchase.purchase_no }}</span>
                  <!-- 临时库位 -->
                  <span>{{ $t("message.temporaryStorageLocation") }}:
                    <span style="color: #fa5058; font-size: 20px;">
                      {{ purchase.order_box_detail_num }}
                    </span>
                  </span>
                </div>
              </div>
            </li>
            <!-- 价格.元 -->
            <li>{{ items.confirm_price }}</li>
            <!--交易/物流号  -->
            <li class="flex2">
              <div class="template">
                <div class="row" v-for="(purchase, purchaseIndex) in items.purchase" :key="purchaseIndex">
                  JY{{ purchaseIndex + 1 }}:
                  <span style="color: #fa5058">{{ purchase.purchase_no }}</span>
                  <p v-for="(express, expressIndex) in purchase.order_purchase_express" :key="expressIndex">
                    WL{{ expressIndex + 1 }}:
                    <span style="color: #2c96e7">{{ express.express_no }}</span>
                  </p>
                </div>
              </div>
            </li>
            <!-- 业务回复 -->
            <li class="flex15">{{ items.y_remark }}</li>
            <!-- 采购备注 -->
            <li class="flex15">{{ items.g_remark }}</li>
            <!-- 配货备注 -->
            <li class="flex15">{{ items.p_remark }}</li>
          </ul>
        </div>
      </div>
      <!-- 箱子状况 -->
      <div class="box">
        <!-- 重量填写 -->
        <div class="box-weight">
          <!-- 重量填写栏： -->
          <h6>{{ $t("message.weightFillingBar") }}:</h6>
          <!-- 列表 -->
          <div class="list">
            <div class="head">
              <!-- 重量 -->
              <div class="item">{{ $t("message.weight") }}KG</div>
              <!-- 箱型 -->
              <div class="item">
                {{ $t("message.boxPile") }}
              </div>
              <!-- 长 -->
              <div class="item">{{ $t("message.length") }}(cm)</div>
              <!-- 宽 -->
              <div class="item">{{ $t("message.width") }}(cm)</div>
              <!-- 高 -->
              <div class="item">{{ $t("message.height") }}(cm)</div>
              <!-- 体积cm3 -->
              <div class="item">{{ $t("message.volume") }}cm3</div>
            </div>
            <div class="content">
              <!-- 重量 -->
              <div class="item">
                <el-input v-model="detail.weight" type="number" onfocus="this.select()"></el-input>
              </div>
              <!-- 箱型 -->
              <div class="item">
                <el-select v-model="detail.attr" placeholder="请选择" @change="setCWK">
                  <el-option v-for="item in attrOption" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <!-- 长 -->
              <div class="item">
                <el-input v-model="detail.c" type="number" onfocus="this.select()"></el-input>
              </div>
              <!-- 宽 -->
              <div class="item">
                <el-input v-model="detail.k" type="number" onfocus="this.select()"></el-input>
              </div>
              <!-- 高 -->
              <div class="item">
                <el-input v-model="detail.g" type="number" onfocus="this.select()"></el-input>
              </div>
              <!-- 体积cm3 -->
              <div class="item">
                {{ (detail.g * detail.k * detail.c) / 1000 }}cm3
              </div>
            </div>
          </div>
        </div>
        <!-- 箱子备注 -->
        <div class="box-remark">
          <!--箱子备注： -->
          <h6>{{ $t("message.boxRemarks") }}</h6>
          <el-input type="textarea" placeholder="请输入内容" v-model="detail.p_remark" resize="none" @blur="updatePRemark"
            :disabled="!isAuth(192)">
          </el-input>
        </div>
      </div>
      <!-- 操作 -->
      <div class="operation-box">
        <div class="operation">
          <!-- 全选 -->
          <el-checkbox v-model="checked" @change="allChecked">
            {{ $t("message.allChecked") }}
          </el-checkbox>
          <!-- 取出商品 -->
          <el-button type="success" size="small" @click="takeOutGoods" v-if="isAuth(190)">
            {{ $t("message.takeOutGoods") }}
          </el-button>
          <!-- 商品移箱 -->
          <el-button type="success" size="small" class="primary" @click="movingGoodsBox" v-if="isAuth(191)">
            {{ $t("message.movingGoodsBox") }}
          </el-button>
          <!-- 保存装箱单信息 -->
          <el-button type="success" size="small" class="primary" @click="saveThePackingListInformation">
            {{ $t("message.saveThePackingListInformation") }}
          </el-button>
          <!-- 打印装箱单 -->
          <el-button size="small" type="success" @click="printPackingList('')">{{ $t("message.printPackingList") }}
          </el-button>
          <!-- 打印装箱单(无单价)-->
          <el-button size="small" type="success" @click="printPackingList('NoPrice')">
            {{ $t("message.printPackingListNoPrice") }}
          </el-button>
          <!-- 标记装箱完了 -->
          <el-button type="primary" size="small" class="primary" @click="markPackingFinished" v-if="isAuth(187)">
            {{ $t("message.markPackingFinished") }}
          </el-button>
          <!-- 打印唛头 -->
          <el-button type="success" size="small" class="primary" @click="printingMarks">
            {{ $t("message.printingMarks") }}
          </el-button>
          <!-- 取消箱子 -->
          <el-button type="success" size="small" class="dark" @click="delBox" v-if="isAuth(186)">
            {{ $t("message.cancelTheBox") }}
          </el-button>
          <!-- 箱子商品总金额 -->
          <span class="kinTotal">
            {{ $t('message.boxKin') }} ：{{ kinTotal.toFixed(2) }}（元）
          </span>
        </div>
      </div>
    </el-dialog>
    <!-- 直接装箱列表进显示 -->
    <div class="detail" v-if="$route.query.id">
      <detailHeader />
      <div class="encasement-status">
        <div class="status">{{ detail.status_name }}</div>
        <div class="order-name">
          <!-- 业务 -->
          <div class="item">{{ $t("message.business") }}:{{ detail.y_name }}</div>
          <!-- 采购 -->
          <div class="item">{{ $t("message.purchase") }}:{{ detail.g_name }}</div>
          <!-- 配货 -->
          <div class="item">
            {{ $t("message.distribution") }}:{{ detail.p_name }}
          </div>
          <!-- 箱号 -->
          <div class="item">
            {{ $t("message.boxNO") }}:{{ detail.order_sn }}-{{ detail.box_no }}
          </div>
        </div>
      </div>
      <!-- 列表 -->
      <div class="encasementDetail">
        <!-- 装箱状态 -->
        <div class="table">
          <ol>
            <!-- 选择 -->
            <li class="flex05">{{ $t("message.choose") }}</li>
            <!-- 订单号 -->
            <li class="flex2">{{ $t("message.orderNumber") }}</li>
            <!--  番号-->
            <li class="flex05">
              {{ $t("message.mash") }}
            </li>
            <!--照片-->
            <li>
              {{ $t("message.pic") }}
            </li>
            <!-- 商品属性 -->
            <li class="flex15">{{ $t("message.commodityAttribute") }}</li>
            <!--本箱装货数  -->
            <li class="flex3">{{ $t("message.quantityOfCargoInThisCase") }}</li>
            <!-- 价格.元 -->
            <li>{{ $t("message.priceY") }}</li>
            <!--交易/物流号  -->
            <li class="flex2">
              {{ $t("message.transactionNumberLogisticsNumber") }}
            </li>
            <!-- 担当、商品备注 -->
            <li class="flex15">{{ $t("message.BearCommodityNoteEditing") }}</li>
            <!-- 采购、商品备注 -->
            <li class="flex15">{{ $t("message.purchaseCommodityNoteEditing") }}</li>
            <!-- 配货。商品备注 -->
            <li class="flex15">{{ $t("message.DistributionBearCommodityNoteEditing") }}</li>
          </ol>
          <!-- 无数据显示 -->
          <div class="noData" v-if="tableData == false">暂无数据</div>
          <!-- 订单详情 -->
          <ul v-for="(items, indexs) in tableData" :key="indexs">
            <!-- 选择 -->
            <li class="flex05">
              <label>
                <el-popover placement="right" title="合计" width="200" trigger="focus">
                  <statistics :selectList="checkedList" />
                  <el-checkbox v-model="items.checked" @change="changeItem" slot="reference"></el-checkbox>
                </el-popover>

              </label>
            </li>
            <!-- 订单号 -->
            <li class="flex2">
              <div>
                <p>
                  <router-link :to="'/orderPaymentDetail?order_sn=' + items.order_sn" target="_blank" class="a-link">
                    {{ items.order_sn }}
                  </router-link>
                </p>
                <p>{{ items.realname }}</p>
              </div>
            </li>
            <!--   番号-->
            <li class="flex05">
              {{ items.sorting }}
            </li>
            <!--照片-->
            <li>
              <div>
                <div class="img">
                  <el-popover placement="right" width="300" trigger="hover">
                    <img :src="items.pic" alt="" style="width: 300px; height: 300px" />
                    <a :href="`https://detail.1688.com/offer/${items.goods_id}.html`" target="_blank" slot="reference">
                      <img :src="items.pic" alt="" />
                    </a>
                  </el-popover>
                  <div class="contraband" v-if="items.forbid_goods != false">
                    <el-popover placement="right" width="200" trigger="hover">
                      <div>
                        {{ items.forbid_goods.type_name }}
                      </div>
                      <img src="@/assets/img/contraband1.png" alt="" slot="reference"
                        v-if="items.forbid_goods.status == 3">
                      <img src="@/assets/img/contraband.png" alt="" slot="reference" v-else>
                    </el-popover>
                  </div>
                </div>
              </div>
            </li>
            <!-- 商品属性 -->
            <li class="flex15">
              <div class="attribute">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(itemDetail, itemIndex) in items.detail_y" :key="itemIndex"
                      style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(itemDetail, itemIndex) in items.detail_y" :key="itemIndex">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!--本箱装货数  -->
            <li class="flex3">
              <div class="purchase">
                <div class="row" v-for="(purchase, purchaseIndex) in items.purchase" :key="purchaseIndex">
                  <span>
                    JY{{ purchaseIndex + 1 }}:{{ purchase.purchase_no }}</span>
                  <!-- 临时库位 -->
                  <span>{{ $t("message.temporaryStorageLocation") }}: <span style="color: #fa5058;font-size: 20px;">
                      {{ purchase.order_box_detail_num }}
                    </span></span>
                </div>
              </div>
            </li>
            <!-- 价格.元 -->
            <li>{{ items.confirm_price }}</li>
            <!--交易/物流号  -->
            <li class="flex2">
              <div class="template">
                <div class="row" v-for="(purchase, purchaseIndex) in items.purchase" :key="purchaseIndex">
                  JY{{ purchaseIndex + 1 }}:
                  <span style="color: #fa5058">{{ purchase.purchase_no }}</span>
                  <p v-for="(express, expressIndex) in purchase.order_purchase_express" :key="expressIndex">
                    WL{{ expressIndex + 1 }}:
                    <span style="color: #2c96e7">{{ express.express_no }}</span>
                  </p>
                </div>
              </div>
            </li>
            <!-- 业务回复 -->
            <li class="flex15">{{ items.y_remark }}</li>
            <!-- 采购备注 -->
            <li class="flex15">{{ items.g_remark }}</li>
            <!-- 配货备注 -->
            <li class="flex15">{{ items.p_remark }}</li>
          </ul>
        </div>
      </div>
      <!-- 箱子状况 -->
      <div class="box">
        <!-- 重量填写 -->
        <div class="box-weight">
          <!-- 重量填写栏： -->
          <h6>{{ $t("message.weightFillingBar") }}:</h6>
          <!-- 列表 -->
          <div class="list">
            <div class="head">
              <!-- 重量 -->
              <div class="item">{{ $t("message.weight") }}KG</div>
              <!-- 箱型 -->
              <div class="item">
                {{ $t("message.boxPile") }}
              </div>
              <!-- 长 -->
              <div class="item">{{ $t("message.length") }}(cm)</div>
              <!-- 宽 -->
              <div class="item">{{ $t("message.width") }}(cm)</div>
              <!-- 高 -->
              <div class="item">{{ $t("message.height") }}(cm)</div>
              <!-- 体积cm3 -->
              <div class="item">{{ $t("message.volume") }}cm3</div>
            </div>
            <div class="content">
              <!-- 重量 -->
              <div class="item">
                <el-input v-model="detail.weight" type="number" onfocus="this.select()"></el-input>
              </div>
              <!-- 箱型 -->
              <div class="item">
                <el-select v-model="detail.attr" placeholder="请选择" @change="setCWK">
                  <el-option v-for="item in attrOption" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <!-- 长 -->
              <div class="item">
                <el-input v-model="detail.c" type="number" onfocus="this.select()"></el-input>
              </div>
              <!-- 宽 -->
              <div class="item">
                <el-input v-model="detail.k" type="number" onfocus="this.select()"></el-input>
              </div>
              <!-- 高 -->
              <div class="item">
                <el-input v-model="detail.g" type="number" onfocus="this.select()"></el-input>
              </div>
              <!-- 体积cm3 -->
              <div class="item">
                {{ (detail.g * detail.k * detail.c) / 1000 }}cm3
              </div>
            </div>
          </div>
        </div>
        <!-- 箱子备注 -->
        <div class="box-remark">
          <!--箱子备注： -->
          <h6>{{ $t("message.boxRemarks") }}</h6>
          <el-input type="textarea" placeholder="请输入内容" v-model="detail.p_remark" resize="none" @blur="updatePRemark"
            :disabled="!isAuth(192)">
          </el-input>
        </div>
      </div>
      <!-- 操作 -->
      <div class="operation-box">
        <div class="operation">
          <!-- 全选 -->
          <el-checkbox v-model="checked" @change="allChecked">
            {{ $t("message.allChecked") }}
          </el-checkbox>
          <!-- 取出商品 -->
          <el-button type="success" size="small" @click="takeOutGoods" v-if="isAuth(190)">
            {{ $t("message.takeOutGoods") }}
          </el-button>
          <!-- 商品移箱 -->
          <el-button type="success" size="small" class="primary" @click="movingGoodsBox" v-if="isAuth(191)">
            {{ $t("message.movingGoodsBox") }}
          </el-button>
          <!-- 保存装箱单信息 -->
          <el-button type="success" size="small" class="primary" @click="saveThePackingListInformation">
            {{ $t("message.saveThePackingListInformation") }}
          </el-button>
          <!-- 打印装箱单 -->
          <el-button size="small" type="success" @click="printPackingList('')">{{ $t("message.printPackingList") }}
          </el-button>
          <!-- 打印装箱单(无单价)-->
          <el-button size="small" type="success" @click="printPackingList('NoPrice')">
            {{ $t("message.printPackingListNoPrice") }}
          </el-button>
          <!-- 标记装箱完了 -->
          <el-button type="primary" size="small" class="primary" @click="markPackingFinished" v-if="isAuth(187)">
            {{ $t("message.markPackingFinished") }}
          </el-button>
          <!-- 打印唛头 -->
          <el-button type="success" size="small" class="primary" @click="printingMarks">
            {{ $t("message.printingMarks") }}
          </el-button>
          <!-- 取消箱子 -->
          <el-button type="success" size="small" class="dark" @click="delBox" v-if="isAuth(186)">
            {{ $t("message.cancelTheBox") }}
          </el-button>
          <!-- 箱子商品总金额 -->
          <span class="kinTotal">
            {{ $t('message.boxKin') }} ：{{ kinTotal.toFixed(2) }}（元）
          </span>
        </div>
      </div>
    </div>
    <!-- 移箱 -->
    <movingGoodsBox :order_sn="detail.order_sn" :list="movingGoodsBoxList" :boxId="id"
      v-if="goodsNeedToBeMovedDialogVisible" />
    <!-- 库位选择 -->
    <warehouse v-if="warehouseDialogVisible" :shelf_type_set="shelf_type_set" :type="type" :boxIds="boxIds" />
    <!-- 打印唛头 -->
    <div v-show="false">
      <Finalshippingmark ref="Finalshippingmark" :detail="detail" />
    </div>
    <!-- 装箱打印 -->
    <div v-show="false">
      <div ref="Packinglist">
        <Packinglist :datas="item" v-for="(item, index) in PackingData" :key="index" />
      </div>
    </div>
  </div>
</template>
<script>
import detailHeader from "@/components/header/detailHeader";
import movingGoodsBox from "@/components/box/movingGoodsBox";
import Finalshippingmark from '@/components/Printedsheet/Finalshippingmark.vue'
import { attrOption } from "@/utlis/options";
import Packinglist from '@/components/Printedsheet/Packinglist'
import statistics from './statistics'
import warehouse from "@/components/common/warehouse";
export default {
  props: {
    id: { type: Number }
  },
  metaInfo() {
    return {
      title: '授权箱子详情',
    };
  },
  components: {
    detailHeader,
    movingGoodsBox,
    Finalshippingmark,
    Packinglist,
    statistics,
    warehouse
  },
  data() {

    return {
      boxID: 0,
      attrOption,
      checked: false,
      tableData: [],
      checkedList: [],
      detail: {
        c: 0,
        k: 0,
        g: 0,
      },
      goodsNeedToBeMovedDialogVisible: false,
      warehouseDialogVisible: false,
      shelf_type_set: [],
      type: '',
      boxIds: [],
      movingGoodsBoxList: [],
      PackingData: [],
      kinTotal: 0,// 箱子金额
      selectList: [],//选中的数据
    };
  },
  created() {
    let route = this.$route
    if (route.name == 'boxDetail' && route.query.verification != this.$md5(route.query.id + '')) {
      return this.$alert('不得直接修改链接进入箱子详情，请从正确位置查看箱子', '警告', {
        confirmButtonText: '确定',
        center: true,
        callback: action => {
          window.open("about:blank", "_top").close();
        }
      });
    }

    this.boxDetail();

  },
  methods: {
    // 箱子详情
    boxDetail() {
      this.boxID = this.id ? this.id : this.$route.query.id
      this.kinTotal = 0
      this.$api.inspectionApi.boxDetail({ id: this.boxID }).then((res) => {
        res.data.list.forEach(item => {
          this.kinTotal += (item.order_detail_this_box_num * item.confirm_price) - 0
        })
        this.detail = res.data;
        this.tableData = res.data.list;
        this.checked = false;
        this.checkedList = [];

      });
    },
    // 单选
    changeItem() {
      this.checkedList = [];
      this.tableData.forEach((item) => {
        if (item.checked) {
          this.checkedList.push(item);
        }
      });
      this.checked = this.tableData.every((item) => item.checked);
      this.$forceUpdate();
    },
    //  全选
    allChecked() {
      this.checkedList = [];
      this.tableData.forEach((item) => {
        item.checked = this.checked;
        if (this.checked) {
          this.checkedList.push(item);
        }
      });
      this.$forceUpdate();
    },
    //商品取出
    takeOutGoods() {
      if (this.checkedList == false)
        return this.$message.error(
          this.$t("message.aBoxWithNoSelectedOperation")
        );
      let list = [];
      this.checkedList.forEach((item) => {
        list.push({
          num: item.order_detail_this_box_num,
          order_box_detail_id: item.purchase[0].order_box_detail_id,
        });
      });
      this.$confirm(
        this.$t("message.whetherToTakeOutTheGoods"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.inspectionApi.outBox({ list }).then((res) => {
            this.$message.success(res.msg);
            this.boxDetail();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 箱子删除
    delBox() {
      this.$confirm(
        "注意: 取消箱子后，该编号之后的箱子编号将前进一位。例如：原来005的，将变成004",
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.inspectionApi.deleteBox({ ids: [this.boxID] }).then((res) => {
            this.$message.success(res.msg);
            window.open("about:blank", "_top").close();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    //保存装箱单信息
    saveThePackingListInformation() {
      let datas = {
        ids: [this.boxID],
        attr: this.detail.attr,
        c: this.detail.c,
        k: this.detail.k,
        g: this.detail.g,
        weight: this.detail.weight,
      };
      this.$api.inspectionApi.updateBoxAttrAndWeight(datas);
    },
    // 备注
    updatePRemark() {
      let datas = {
        box_id: this.boxID,
        p_remark: this.detail.p_remark,
      };
      this.$api.inspectionApi.updatePRemark(datas);
    },
    // 标记装箱完了
    markPackingFinished() {
      this.boxIds = [this.boxID];
      this.shelf_type_set = [1, 3];
      this.type = 11;
      this.warehouseDialogVisible = true;
    },
    // 选择库位并装箱完成后刷新详情
    markPackingFinishedSuccess() {
      this.warehouseDialogVisible = false;
      this.boxDetail();
    },
    // 取到长宽高
    setCWK(e) {

      let arr = e.split("*");
      this.detail.c = arr[0];
      this.detail.k = arr[1];
      this.detail.g = arr[2];
    },
    //移箱
    movingGoodsBox() {
      if (this.checkedList == false)
        return this.$message.error(
          this.$t("message.aBoxWithNoSelectedOperation")
        );
      this.movingGoodsBoxList = [];
      this.checkedList.forEach((item) => {
        this.movingGoodsBoxList.push(item);
      });
      this.goodsNeedToBeMovedDialogVisible = true;
    },
    // 移箱完成
    moveOutSuccess() {
      this.goodsNeedToBeMovedDialogVisible = false;
      this.boxDetail();
    },
    //打印唛头
    printingMarks() {
      let datas = {
        ids: [this.boxID],
        attr: this.detail.attr,
        c: this.detail.c,
        k: this.detail.k,
        g: this.detail.g,
        weight: this.detail.weight,
      };
      this.$api.inspectionApi.updateBoxAttrAndWeight(datas).then(() => {
        this.$nextTick(() => {
          this.$print(this.$refs.Finalshippingmark);
        });
      })

    },
    //打印装箱单
    printPackingList(type) {
      let datas = {
        ids: [this.boxID],
        attr: this.detail.attr,
        c: this.detail.c,
        k: this.detail.k,
        g: this.detail.g,
        weight: this.detail.weight,
      };
      this.$api.inspectionApi.updateBoxAttrAndWeight(datas).then(() => {
        let data = {
          height: this.detail.g,
          id: '',
          length: this.detail.c,
          number: this.detail.box_no,
          porder: {
            y_admin: { realname: this.detail.y_name },
            p_admin: { realname: this.detail.p_name },
            g_admin: { realname: this.detail.g_name },
          },
          porder_freight_detail: [],
          porder_sn: this.detail.order_sn,
          total: 0,
          weight: this.detail.weight,
          width: this.detail.k,
        }
        this.detail.list.forEach(item => {
          console.log(item);

          data.porder_freight_detail.push({
            order_detail: {
              client_remark: item.client_remark,
              detail: item.detail_y,
              id: item.order_detail_id,
              order_sn: item.order_sn,
              pic: item.pic,
              sorting: item.sorting,
              confirm_price: !type ? item.confirm_price : '',
            },
            num: item.order_detail_this_box_num
          })
          data.total += item.order_detail_this_box_num
        })
        this.PackingData = [data];
        this.$nextTick(() => {
          this.$print(this.$refs.Packinglist);
        });
      })
    },
  },
};
</script>
<style lang='scss' scoped>
/deep/.el-checkbox__inner {
  transform: scale(2) !important;
}

.encasementDetail {
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;
  padding: 24px;
  margin: 24px;
  margin-top: 0;
}

.encasement-status {
  height: 60px;
  display: flex;
  justify-content: space-between;
  margin: 24px 24px 0;

  .status {
    width: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    color: #fff;
    background-color: #15ad3c;
    border-radius: 4px 4px 0px 0px;
  }

  .order-name {
    display: flex;
    line-height: 60px;
    padding-right: 24px;

    .item {
      margin-left: 50px;
    }
  }
}

.table {
  ol {
    display: flex;
    font-size: 14px;
    height: 60px;
    background-color: #edeff4;
    color: #333;
    position: sticky;
    top: 0px;
    left: 240px;
    z-index: 99;
    margin-bottom: 20px;

    li {
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 20px;
    }
  }

  .noData {
    padding: 20px 0;
    text-align: center;
  }

  ul {
    display: flex;
    border-bottom: 1px solid #e8e8e8;
    padding: 10px 0;
    font-size: 14px;
    transition: 0.25s;

    &:hover {
      background-color: #eee;
      cursor: pointer;
    }

    li {
      width: 100%;
      word-break: break-all;

      .template {
        width: 100%;
      }
    }

    /deep/.el-input {
      width: 100px;
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0 5px;
  }

  .flex05 {
    flex: 0.5;
    position: relative;

    a {
      position: absolute;
      right: 0;
      top: 0;
      height: 20px;
      width: 20px;
      background-color: #f56c6c;
      border-radius: 50%;
      line-height: 20px;
      text-align: center;
      color: #fff;
    }

    label {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .flex15 {
    flex: 1.3;
  }

  .flex2 {
    flex: 1.8;

    /deep/ .el-textarea__inner {
      height: 40px;
      padding: 0 2px;
      line-height: 18px;
    }
  }

  .flex3 {
    flex: 2.5;
  }

  img {
    width: 60px;
    height: 60px;
    border-radius: 4px;

  }

  .img {
    position: relative;

    .contraband {
      position: absolute;
      top: -30px;
      right: -20px;

      img {
        width: 30px;
        height: 30px;
      }
    }
  }

  .template {
    width: 100%;
    text-align: left;
  }

  .purchase {
    width: 100%;

    .row {
      display: flex;
      margin: 5px;
      justify-content: space-between;
    }
  }
}

.box {
  margin: 24px;
  display: flex;

  h6 {
    font-size: 18px;
    margin-bottom: 16px;
  }

  .box-weight {
    width: 1092px;
    padding: 24px;
    border-radius: 8px;
    background: #f0f9eb;
    margin-right: 24px;

    .list {
      background-color: #fff;
      border: 1px solid #edeff4;
      border-radius: 4px 4px 0px 0px;

      .head {
        display: flex;
        border-bottom: 1px solid #edeff4;

        .item {
          padding: 18px 0;
        }
      }

      .item {
        display: flex;
        flex: 1;
        justify-content: center;
        align-items: center;
        border-right: 1px solid #edeff4;

        &:nth-last-child(1) {
          border: 0;
        }
      }

      .content {
        display: flex;

        .item {
          padding: 24px;
        }
      }
    }
  }

  .box-remark {
    width: 756px;
    padding: 24px;
    background: #edeff4;
    border-radius: 8px;

    /deep/.el-textarea__inner {
      height: 146px;
    }
  }
}

.operation-box {
  margin: 0 24px;
  padding: 24px;
  background-color: #f8f8f8;
  border-radius: 8px;
  position: sticky;
  bottom: 0;
  z-index: 9;

  .operation {
    background-color: #edeff4;
    padding: 16px 24px;

    .el-button {
      margin-left: 30px;
    }

    span {
      margin-left: 30px;
      font-size: 14px;
      cursor: pointer;
    }
  }
}

.kinTotal {
  color: #f56c6c;
  font-size: 30px !important;
  font-weight: bold
}
</style>
